import React from "react";

export const ConfusedKerry = () => {
    return <div className={"confused-kerry"} />;
};
